import { isLocalEnvByUrl } from 'src/constants/config.constants';
import { GATEWAY_URL_LS_KEY } from 'src/constants/local-storage.constants';
import { ROOT_PATH } from 'src/constants/routes.constants';
import { AmpConfig } from 'src/interfaces/amp-config.types';
import { loggerService } from 'src/services/logger.service';

let ampConfig: AmpConfig | null = null;

export const fetchAmpConfig = async () => {
  const ampConfigPath = isLocalEnvByUrl() ? ROOT_PATH : '';

  const res = await fetch(
    `${window.location.origin}${ampConfigPath}/amp-config.json`,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );

  ampConfig = await res.json();
};

export const getAmpConfig = () => {
  if (!ampConfig) {
    throw new Error('AmpConfig not loaded');
  }

  return ampConfig;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getAmpConfigFlags = () => getAmpConfig().flags['student-home'];

/**
 * saves gateway url in local storage to avoid fetching of amp-config by @amplify/amp-api lib
 * */
export const saveApiGatewayUrl = () => {
  try {
    window.localStorage.setItem(GATEWAY_URL_LS_KEY, getAmpConfig().gateway);
  } catch (e) {
    loggerService.logError(e);
  }
};
